import { OrgMemberRole } from './org-member';

export interface Permissions {
  allowAll: boolean;
  rejectAll: boolean;
  allowUserIds: number[];
  rejectUserIds: number[];
}

export enum PermissionsResourceType {
  ORG = 'org',
  WORKSPACE = 'workspace',
  PORTAL = 'portal',
  PORTAL_MENU_ITEM = 'portalMenuItem',
  PORTAL_PAGE = 'portalPage',
  NOTE = 'note',
  NOTES_FOLDER = 'notesFolder',
}

export enum PermissionsAccessMode {
  NO_ACCESS,
  FULL_ACCESS,
  SHARED_ACCESS,
}

export const AllowAllPermissions: Permissions = {
  allowAll: true,
  rejectAll: false,
  allowUserIds: [],
  rejectUserIds: [],
};

export interface PermissionsChangePayload extends Permissions {
  target: PermissionsResourceType;
  targetId: string;
  workspaceId?: string;
  invites?: { email: string; role: string; orgRole?: OrgMemberRole }[];
  portalUrl?: string;
  fetchOrgMembers?: boolean;
  orgId?: string;
}
